var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDishSlice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 103,
    viewBox: "0 0 191 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.729 11.5392C103.006 17.2649 72.8504 39.9309 49.1117 60.0353C36.2027 69.8156 18.3997 87.8639 26.7218 93.904C37.4248 101.672 54.8301 75.0292 68.6276 62.1234C97.0867 35.5034 128.386 23.1284 146.768 19.1335C165.151 15.1387 212.453 5.81345 157.729 11.5392Z",
    fill: "#EACFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16506 92.9541C5.19054 83.2046 13.7463 81.6878 19.4523 78.4443C21.5538 77.1202 25.2919 75.1877 23.4323 78.0502C21.1079 81.6284 11.1396 102.704 8.16506 92.9541Z",
    fill: "#EACFEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.043 6.48021C165.359 2.75538 167.121 5.40289 169.801 6.55954C170.876 6.95017 172.502 7.76037 170.411 7.87613C167.798 8.02083 152.728 10.205 159.043 6.48021Z",
    fill: "#EACFEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.363 22.3462C89.2342 27.7411 48.3295 56.6305 31.7398 70.9274C31.3257 71.2842 30.8245 71.4883 30.2795 71.5303C29.377 71.5998 28.841 70.5435 29.4299 69.8562L32.8868 65.822C34.936 63.8283 44.2899 56.572 65.3112 43.4966C91.588 27.1523 113.234 22.1796 125.363 22.3462Z",
    fill: "#EACFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDishSlice);
export default __webpack_public_path__ + "static/media/dishSlice.b534844c3ec869b35450a3b2c3fdff11.svg";
export { ForwardRef as ReactComponent };